import { useMap } from '@/state/context/MapContext';
import { Polygon } from 'ol/geom';
import { useEffect } from 'react';

/**
 * Polygon tracing mainland Norway in EPSG:25833 (UTM33).
 * The constraint only fires when the entire visible viewport has zero overlap
 * with this polygon — i.e. the user has panned completely out of Norway.
 */
const NORWAY_COORDS: [number, number][] = [
    [637229.728, 7599645.042],
    [718509.891, 7578647.667],
    [742893.939, 7662637.168],
    [797080.714, 7625383.761],
    [906808.934, 7625383.761],
    [941353.003, 7683634.544],
    [944062.342, 7786589.416],
    [995539.778, 7800813.445],
    [1047694.549, 7704631.919],
    [1135070.724, 7785234.747],
    [1141844.071, 7920024.35],
    [874974.203, 7968792.447],
    [623005.7, 7814360.139],
    [335815.792, 7505495.521],
    [359522.506, 7412023.334],
    [259954.307, 7202726.915],
    [-27235.601, 6958886.428],
    [-76003.699, 6887088.951],
    [-101065.082, 6610736.398],
    [-60425.001, 6515232.207],
    [-6238.226, 6446821.403],
    [76396.606, 6416341.342],
    [203735.528, 6518618.88],
    [312786.412, 6518618.88],
    [369682.526, 6663568.504],
    [390002.567, 6804454.119],
    [359522.506, 7022555.888],
    [404903.93, 7101126.712],
    [453672.028, 7089612.022],
    [474669.403, 7147862.806],
    [443512.007, 7166828.177],
    [635197.724, 7551554.28],
    [637229.728, 7599645.042], // close polygon
];

const norwayPolygon = new Polygon([NORWAY_COORDS]);

export const NorwayBoundsConstraint = () => {
    const { map } = useMap();

    useEffect(() => {
        const handleMoveEnd = () => {
            const size = map.getSize();
            const view = map.getView();
            const center = view.getCenter();
            if (!size || !center) return;

            const viewExtent = view.calculateExtent(size);
            if (!norwayPolygon.intersectsExtent(viewExtent)) {
                view.animate({
                    center: norwayPolygon.getClosestPoint(center),
                    duration: 300,
                });
            }
        };

        map.on('moveend', handleMoveEnd);
        return () => map.un('moveend', handleMoveEnd);
    }, [map]);

    return null;
};
